<template>
  <h1>Events For Good</h1>
  <div class="events">
    <EventCard v-for="(event, index) in events" :key="index" :event="event"/>  
  </div>
</template>

<script>
// @ is an alias to /src
import EventCard from "@/components/EventCard.vue";
import EventService from "@/services/EventService.js";

export default {
  name: "EventList",
  components: {
    EventCard
  },
  data() {
    return {
      events: null
    }
  },
  created() {
    EventService.getEvents()
      .then(response => {
        this.events = response.data;
      }).catch(error => {
        console.log('error:', error)
      })
  }
};
</script>

<style scoped>
  .events {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
  }
</style>